module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/03_shape-md-64ba3f51d139c5b1e8c5a21e358e0d12.png";